import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiSend } from "react-icons/fi";
import api from "../../api";
import { useAuth } from "../../AuthContext";
import { MAIN_URL, SHARE_URL } from "../../utils/appHost";

/** Sign-in for share.pic-loud.com. Same Pic-Loud account; Google returns here via ?next=. */
export default function ShareLogin() {
  const { t } = useTranslation();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(new URLSearchParams(location.search).get("error") ? t("login_page.google_auth_failed") : "");
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    const next = `${SHARE_URL}${from}`;
    window.location.href = `${api.defaults.baseURL}/auth/google?next=${encodeURIComponent(next)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password, remember_me: true });
      await checkAuth();
      navigate(from, { replace: true });
    } catch {
      setError(t("share.login.invalid"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shr-card">
      <div className="shr-empty-icon" style={{ marginBottom: 16 }}><FiSend size={22} /></div>
      <h1 className="shr-title">{t("share.login.title")}</h1>
      <p className="shr-subtitle">{t("share.login.subtitle")}</p>

      {error && <div className="shr-callout error">{error}</div>}

      <button type="button" className="shr-btn ghost block" onClick={googleLogin}>
        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        {t("login_page.google_button")}
      </button>

      <div className="shr-divider">{t("login_page.or_text")}</div>

      <form onSubmit={submit}>
        <div className="shr-field">
          <label className="shr-label" htmlFor="shr-email">{t("login_page.email_label")}</label>
          <input id="shr-email" className="shr-input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="shr-field">
          <label className="shr-label" htmlFor="shr-password">{t("login_page.password_label")}</label>
          <input id="shr-password" className="shr-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button type="submit" className="shr-btn primary block" disabled={loading}>
          {t("login_page.login_button")}
        </button>
      </form>

      <p className="shr-muted" style={{ textAlign: "center", marginTop: 18 }}>
        {t("share.login.no_account")}{" "}
        <a href={`${MAIN_URL}/signup`} style={{ color: "#6366f1", fontWeight: 600, textDecoration: "none" }}>
          {t("share.login.signup")}
        </a>
      </p>
    </div>
  );
}
